import { createAdminApi, type AdminPage, type AdminUserSummary } from '@/admin/adminApi';
import { useAdminQuery, type QueryState } from '@/admin/data/useAdminQuery';
import { useHttpClient } from '@/app/providers';

import { queryKey, serverFilters, type AccountListQuery } from './accountFilters';

/** Taille de page des listes de comptes ; le serveur accepte jusqu'a 100. */
export const ACCOUNTS_PER_PAGE = 25;

/**
 * Une page de comptes et l'instant ou elle a ete lue : les mentions relatives
 * (« il y a 4 min ») se calculent depuis cet instant, jamais depuis une horloge
 * qui avancerait toute seule sous les yeux de l'exploitant.
 */
export interface LoadedAccounts {
  readonly page: AdminPage<AdminUserSummary>;
  readonly loadedAt: number;
}

/**
 * Lecture de `GET /admin/users` avec les filtres de la requete. Chaque lecture
 * ecrit une ligne `admin.access` : elle ne part donc que sur un geste (changement
 * de vue, de filtre ou de page, « Actualiser », retour sur l'onglet).
 */
export const useAccountsList = (
  query: AccountListQuery,
  options: { readonly enabled: boolean; readonly token: number },
): QueryState<LoadedAccounts> => {
  const http = useHttpClient();

  return useAdminQuery<LoadedAccounts>(
    `accounts|${queryKey(query)}`,
    async () => ({
      page: await createAdminApi(http).listUsers(query.search, query.page, ACCOUNTS_PER_PAGE, serverFilters(query)),
      loadedAt: Date.now(),
    }),
    options,
  );
};
